import React from 'react';

import type { Account } from '../../generated-types';
import AccountListElement from './AccountListElement';
import NoAccountsCards from './NoAccountsCards';

import './AccountList.scss';

interface Props {
    accounts: Account[];
    detailsLink?: string;
    hideDecimals?: boolean;
}

const AccountList: React.FC<Props> = ({ accounts, detailsLink, hideDecimals = false }) => {
    if (!accounts || accounts.length === 0) {
        return <NoAccountsCards />;
    }

    return (
        <>
            {accounts.map((account) => (
                <React.Fragment key={account.accountId.value}>
                    <AccountListElement account={account} detailsLink={detailsLink} hideDecimals={hideDecimals} />
                </React.Fragment>
            ))}
        </>
    );
};

export default AccountList;
